module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-0a822742bb8661445901fedf92e2c036.jpg";